<div class="border-b border-gray-200 relative">
  @if (canScrollLeft) {
    <button type="button"
      (click)="scrollBy('left')"
      class="absolute left-0 top-1/2 -translate-y-1/2 z-10 p-1"
      aria-label="Scroll left">
      ‹
    </button>
  }

  <div class="mx-6">
    <nav class="-mb-px flex space-x-4 overflow-x-auto no-scrollbar" #scrollContainer (scroll)="onScroll()" aria-label="Tabs">
      @for (pane of panes; track pane.id; let i = $index) {
        <button type="button"
          (click)="select(pane)"
          [disabled]="pane.disabled"
          class="whitespace-nowrap py-4 px-3 border-b-2 font-medium transition-colors duration-200"
          [attr.data-tab-id]="pane.id"
                [ngClass]="{
                  'border-neutral-600 dark:border-white': activeId() === pane.id,
                  'border-transparent text-gray-300 hover:text-gray-100 hover:border-gray-100': activeId() !== pane.id,
                  'opacity-50 cursor-not-allowed': pane.disabled
                }">
          {{ pane.label || pane.id }}
        </button>
      }
    </nav>
  </div>

  @if (canScrollRight) {
    <button type="button"
      (click)="scrollBy('right')"
      class="absolute right-0 top-1/2 -translate-y-1/2 z-10 p-1"
      aria-label="Scroll right">
      ›
    </button>
  }
</div>
<div class="pt-4">
  <ng-content></ng-content>
</div>
